import { render } from "./EditDocumentView.vue?vue&type=template&id=70a7d0e0"
import script from "./EditDocumentView.vue?vue&type=script&lang=js"
export * from "./EditDocumentView.vue?vue&type=script&lang=js"

import "./EditDocumentView.vue?vue&type=style&index=0&id=70a7d0e0&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__